import { Component, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';

@Component({
  selector: 'ps-ui-view-repondent-modal',
  templateUrl: './view-repondent-modal.component.html',
  styleUrls: ['./view-repondent-modal.component.css'],
})
export class ViewRepondentModalComponent implements OnInit {
  list: string[] = [];
  constructor(
    @Inject(ModalData) private _modalData: Array<{ psid: string }>,
    private _modalRef: ModalRef<ViewRepondentModalComponent, string>
  ) {}

  ngOnInit(): void {
    this.list = this._modalData.map((psidObj) => psidObj.psid);
  }
}
